var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { emptyCategoryGilroy, primaryHeadingColor, secondaryFont, wMBold, } from '../../../../../Utils/utilsStyle';
import styled from 'styled-components';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\ndisplay: flex;\nflex-direction: column;\nalign-items: center;\njustify-content: center;\nmin-height: 192px;\n.empty-prompt-img {\n  height: 144px;\n}\n.empty-text-prompt {\n  color: ", ";\n  text-align: center;\n  font-family: ", ";\n  font-size: 12px;\n  font-weight: ", ";\n  line-height: 16px;\n  letter-spacing: -0.709px;\n  margin-top: -8px;\n  margin-bottom: 0px;\n}\n"], ["\ndisplay: flex;\nflex-direction: column;\nalign-items: center;\njustify-content: center;\nmin-height: 192px;\n.empty-prompt-img {\n  height: 144px;\n}\n.empty-text-prompt {\n  color: ", ";\n  text-align: center;\n  font-family: ", ";\n  font-size: 12px;\n  font-weight: ", ";\n  line-height: 16px;\n  letter-spacing: -0.709px;\n  margin-top: -8px;\n  margin-bottom: 0px;\n}\n"])), primaryHeadingColor, secondaryFont, wMBold);
var EmptyCategory = function EmptyCategory(props) {
    var text = props.text;
    return (_jsxs(Wrapper, { children: [_jsx("img", { src: emptyCategoryGilroy, alt: "empty-state-prompt", className: "empty-prompt-img" }), _jsx("h3", __assign({ className: "empty-text-prompt" }, { children: text }))] }));
};
export default EmptyCategory;
var templateObject_1;
